<template>
<div>
    <vs-table
        v-model="selectedRow"
        :key="componentKey"
        >
        <template #header>
            <div class="grid">
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="11">
                        <h4>Códigos de Sesión</h4> 
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="1">
                        <vs-button v-if="tablaData" size="mini" large circle icon floating @click="activeCrear=!activeCrear" :disabled="!programa">
                            <i class='fas fa-plus mini-icon' ></i>
                        </vs-button>
                        <modal-crear-codigo v-model="activeCrear" :institucion="institucion"  :list-comp-academico="listCompAcademico" :programa="programa" :list-status="listStatus" @refreshTable="tablaCodigos" :cicloEscolar="cicloEscolar" :escalas_especifica="escalas_especifica" :nivel="nivel" :grado="grado"></modal-crear-codigo>
                        <modal-editar-codigo v-model="activeEditar" :row-data="selectedRow" :institucion="institucion" :list-comp-academico="listCompAcademico"  :list-status="listStatus" @refreshTable="tablaCodigos" :cicloEscolar="cicloEscolar" :programa="programa" :escalas_especifica="escalas_especifica" :nivel="nivel" :grado="grado"></modal-editar-codigo>
                        <modal-eliminar-codigo v-model="activeEliminar" :row-data="selectedRow" @refreshTable="tablaCodigos" :cicloEscolar="cicloEscolar" :programa="programa"></modal-eliminar-codigo>
                    </vs-col>
                </vs-row>
            </div>
        </template>
        <template #thead>
          <vs-tr>
            <vs-th style="width: 20px !important;">
            </vs-th>
            <vs-th>
              Nombre
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in tablaData"
            :data="tr"
            :is-selected="(selectedRow && selectedRow.id) == (tr &&tr.id)"
            not-click-selected
            open-expand-only-td
          >
            <vs-td style="width: 20px !important;" class="text-center">
                ▼
            </vs-td>
            <vs-td edit @click="selectedRow = tr; tipoboton = 'loading'">
                <strong>{{tr.orden_materia}}. {{ tr.alias }}</strong>
            </vs-td>

            <template #expand>
                <div class="con-content">
                    <div>
                    <p>
                        {{ tr.asignatura && tr.asignatura.nombre ? tr.asignatura.nombre : 'Sin nombre de materia' }}
                    </p>
                    <p>
                        {{ tr.ciclo_escolar && tr.ciclo_escolar.nombre_ciclo ? tr.ciclo_escolar.nombre_ciclo : 'Sin nombre de Ciclo Escolar' }}
                    </p>
                    <p>
                        {{ tr.componente_academico && tr.componente_academico.nombre ? tr.componente_academico.nombre : 'Sin nombre de Componente Académico' }}
                    </p>
                    <p>
                        Capacidad :{{ tr.capacidad && tr.capacidad > 0 ? tr.capacidad : 'Sin capacidad definida' }}
                    </p>
                    <p>
                        Promedia :{{ tr.promedia }}
                    </p>
                    </div>
                    <div class="grid">
                        <vs-row >
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" w="6">
                                <vs-button border primary @click="activeEditar=!activeEditar; selectedRow = tr; tipoboton = 'codigo'">
                                    <i class="fas fa-edit"></i>
                                </vs-button>
                            </vs-col>
                            <vs-col v-if="!tr.academico_sesiones[0]" vs-type="flex" vs-justify="center" vs-align="center" w="6">
                                <vs-button  border danger @click="activeEliminar=!activeEliminar; selectedRow = tr; tipoboton = 'codigo'">
                                    <i class="fas fa-trash"></i>
                                </vs-button>
                            </vs-col>
                            <vs-col w="12" v-else>
                                <md-chip class="mb-1 fontMedium mini-chip col-red" >Ya cuenta con sesiones registradas, por esto, no se puede eliminar.</md-chip>
                            </vs-col>
                        </vs-row>
                    </div>
                </div>
            </template>
          </vs-tr>
        </template>
        <template #footer>
                <vs-pagination  v-model="page" :length="pages" />
        </template>
      </vs-table>
    </div>
</template>

<script>
import ModalEditarCodigo from '../action-modals/codigos/editar'
import ModalCrearCodigo from '../action-modals/codigos/crear'
import ModalEliminarCodigo from '../action-modals/codigos/eliminar'
import catalogos from '../../../../api/requests/catalogos.js'
import crns from '../../../../api/requests/crns'

export default {
    props:[
        'institucion',
        'value',
        'cicloEscolar',
        'programa',
        'ejecutar',
        'grado',
        'escalas_especifica',
        'nivel'
    ],   
    data () {
        return {
            activeEditar: false,
            activeCrear: false,
            activeEliminar: false,
            selectedRow: null,
            listCiclos: [],
            listCompAcademico:[],
            listPrograma: [],
            listStatus: catalogos.getStatus(),
            tablaData: [],
            page: 1,
            pages: 0,
            max: 15,
            programasId: (new Date()).getTime(),
            componentKey: 0,
            tipoboton: '',
            sesionLength: 0
        }
    },
    methods: {
        forceRerender() {
            this.componentKey += 1;
        }, 
        async listadosPorInstitucion () {
            if (this.cicloEscolar) {
                try {
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    const { data: compAcademicos } = await catalogos.getComponentesAcademicos(this.institucion, params)
                    this.listCompAcademico = compAcademicos
                } catch (error) {
                    
                }
            }
        },
        async tablaCodigos () {
            if(this.institucion == ''){
                this.errorInstituto = true
            }else{
                this.errorInstituto = false
            }

            if(this.cicloEscolar == ''){
                this.errorCiclo = true
            }else{
                this.errorCiclo = false
            }

            if(this.programa == ''){
                this.errorGrupo = true
            }else{
                this.errorGrupo = false
            }

            if(this.programa == '' || this.institucion == '' || this.cicloEscolar == ''){
                return false
            }
            
            const loading = this.$vs.loading()
            try {
                let params = {
                    page: this.page || 1,
                    size: this.max || 20,
                    ciclo_escolar_id: this.cicloEscolar,
                    programa_id: this.programa,
                }
                if(this.grado != ''){
                    params.grado_id = this.grado
                }
                const { data: responseCrns = null } = await crns.listadoCrn (this.institucion, params) || {}
                const { data: dataCrns = [], per_page = 20, total = 0 } = responseCrns || {}
                this.pages = Math.ceil(total/per_page) || 0
                this.tablaData = dataCrns
                if(!this.tablaData[0]){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'warn',
                        position: null,
                        title: 'Sin información'
                    })
                }
                loading.close()
            } catch (error) {
                loading.close()
                this.tablaData = []
                this.pages = 1
            }
        },
        seleccionados(val){
            this.selectedRow = val
        }
    },
    components: {
        ModalEditarCodigo,
        ModalCrearCodigo,
        ModalEliminarCodigo
    },
    watch:{
        cicloEscolar(){
            this.listadosPorInstitucion()
        },
        selectedRow (val) {
            if (val){
                this.$emit('input', val);
            }
        },
        tipoboton(){
            this.$emit('tipoboton', this.tipoboton);
        },
        ejecutar(){
            this.tablaCodigos()
        },
        page(){
            this.tablaCodigos()
        },
        tablaData(){
            this.forceRerender()
        }
    }
}
</script>

<style>
div.tabla > div.vs-table > table{
    margin: 3% 0 !important;
    width: 100% !important;
}
</style>

<style lang="scss" scoped>

    .cincuenta {
        width: 50px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
.salto {
    display: block;
}

.mini-icon {
     font-size: 0.7rem !important;
}

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}
</style>